import { render, staticRenderFns } from "./TotalBrandsBox.vue?vue&type=template&id=2cd2ef3a&scoped=true&"
import script from "./TotalBrandsBox.vue?vue&type=script&lang=ts&"
export * from "./TotalBrandsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd2ef3a",
  null
  
)

export default component.exports